import classNames from 'classnames/bind';
import React from 'react';

import MissionList from './01_MissionList';
import RobotList from './02_RobotList';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Guide = () => {
  return (
    <div className={cx('container')}>
      <MissionList />
      <RobotList />
    </div>
  );
};

export default Guide;
